import React from 'react'
import { LocaleContext } from 'styles/locale-provider'
import { useLocation } from '@reach/router'
import { navigate } from 'gatsby'

import { langList } from '../../../styles/locale-provider'
import { Wrap } from './index.styled'

const SelectLanguage = ({ list = langList }) => {
  const { lang, setLang } = React.useContext(LocaleContext)
  const { pathname } = useLocation()

  const getNewUrl = (newLang) => {
    const urlLang = pathname.split('/')[1]
    if (urlLang === '') return `/${newLang}${pathname}`

    const oldL = langList.find((l) => urlLang === l.key)
    if (oldL && oldL.key) { return pathname.replace(`/${oldL.key}/`, `/${newLang}/`) }
  }

  return (
    <Wrap>
      {lang}
      <ul>
        {list.map((l) => {
          if (lang != l.key) {
            return (
              <li
                key={`lang-item-${l.key}`}
                onClick={() => {
                  setLang(l.key)
                  navigate(getNewUrl(l.key))
                }}
              >
                {l.value}
              </li>
            )
          }
        })}
      </ul>
    </Wrap>
  )
}

export default SelectLanguage
